import { useId } from 'react';
import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react';
import { Icon } from './icon';

type BaseProps = {
  label?: string;
  hint?: string;
  error?: string;
};

type InputFieldProps = BaseProps & InputHTMLAttributes<HTMLInputElement> & { area?: false };
type AreaFieldProps = BaseProps & TextareaHTMLAttributes<HTMLTextAreaElement> & { area: true };

export function Field(props: InputFieldProps | AreaFieldProps) {
  const { label, hint, error, id, area, className, ...rest } = props as BaseProps & {
    id?: string;
    area?: boolean;
    className?: string;
  } & Record<string, unknown>;
  const generatedId = useId();
  const fieldId = id ?? generatedId;

  return (
    <div>
      {label && (
        <label className="wb-label" htmlFor={fieldId}>
          {label}
        </label>
      )}
      {area ? (
        <textarea
          id={fieldId}
          className={`wb-field wb-field--area ${className ?? ''}`}
          {...(rest as TextareaHTMLAttributes<HTMLTextAreaElement>)}
        />
      ) : (
        <input
          id={fieldId}
          className={`wb-field ${className ?? ''}`}
          {...(rest as InputHTMLAttributes<HTMLInputElement>)}
        />
      )}
      {error ? (
        <div
          className="wb-small"
          style={{
            color: 'var(--danger)',
            margin: '7px 3px 0',
            display: 'flex',
            gap: 6,
            alignItems: 'center',
          }}
        >
          <Icon name="alert" size={15} />
          {error}
        </div>
      ) : hint ? (
        <div className="wb-tiny" style={{ margin: '7px 3px 0' }}>
          {hint}
        </div>
      ) : null}
    </div>
  );
}
